import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCog,
  faBolt
} from '@fortawesome/free-solid-svg-icons';

const SupportEngineSettingsSidebar = ({ activeSubTab = 'atajos', setActiveSubTab }) => {
  const menuItems = [
    {
      id: 'atajos',
      label: 'Atajos',
      icon: faBolt,
      activeColor: '#059669',
      badge: null
    }
  ];

  return (
    <aside className="se-subsidebar">
      {/* Sub-sidebar Header */}
      <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
        <div
          className="d-flex align-items-center justify-content-center rounded-2"
          style={{ width: '32px', height: '32px', backgroundColor: '#e0e7ff', color: '#4338ca' }}
        >
          <FontAwesomeIcon icon={faCog} style={{ fontSize: '0.95rem' }} />
        </div>
        <div>
          <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '0.95rem', lineHeight: 1.2 }}>
            Configuración
          </h6>
          <small className="text-muted" style={{ fontSize: '0.72rem' }}>
            Mesa de Ayuda
          </small>
        </div>
      </div>

      {/* Submenu Items - Styled exactly like the main sidebar */}
      <nav className="d-flex flex-column gap-1 flex-grow-1">
        {menuItems.map(item => {
          const isActive = activeSubTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveSubTab(item.id)}
              className={`se-nav-btn d-flex justify-content-between align-items-center ${isActive ? 'active' : ''}`}
            >
              <div className="d-flex align-items-center gap-2">
                <FontAwesomeIcon
                  icon={item.icon}
                  style={{
                    color: isActive ? item.activeColor || '#4338ca' : '#64748b',
                    width: '18px'
                  }}
                />
                <span>{item.label}</span>
              </div>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default SupportEngineSettingsSidebar;
